"use strict";
var debounce = require("lodash/debounce");

$(document).ready(function () {
    const $communityAssets = $(".vibe-community-asset");

    $communityAssets.each(function (index, element) {
        const $container = $(element);

        const tabButtonObserver = new MutationObserver(() => {
            const $tabButtons = $container.find("button").filter(function () {
                return $(this).siblings("button").length > 0; 
            });

            if ($tabButtons.length > 0) {
                initTabButtonCustomizations($tabButtons);
                tabButtonObserver.disconnect();
            }
        });

        const loadMoreButtonObserver = new MutationObserver(debounce(() => {
            const $loadMoreButton = $container.find("button").filter(function () {
                return $(this).html().indexOf("Load More") > -1; 
            });

            if ($loadMoreButton.length > 0) {
                initLoadMoreButtonCustomizations($loadMoreButton);
            }
        }, 250));

        tabButtonObserver.observe(element, { childList: true, subtree: true });
        loadMoreButtonObserver.observe(element, { childList: true, subtree: true });
    });
});

function initTabButtonCustomizations($buttons) {
    const containerId = $buttons.closest("[id]").attr("id");

    $buttons.parent().addClass("m-vibe__filters");
    $buttons.first().addClass("selected");

    applyTranslations($buttons);

    $buttons.on("click", function() {
        const $this = $(this);
        
        setTimeout(function() {
            $this.addClass("selected");
        }, 0);
    });

    // overwrite dynamic styles
    const style = document.createElement("style");

    style.type = "text/css";
    style.innerHTML = `
        #${containerId} .m-vibe__filters button.selected{
            border-bottom-width: 1px !important;
        }

        #${containerId} .m-vibe__filters button.selected:hover{
            border-bottom-color: #74ecf7 !important;
        }
    `;
    document.head.appendChild(style);
}

function initLoadMoreButtonCustomizations($buttons) {
    applyTranslations($buttons);
    $buttons.addClass("m-vibe__load-more-btn");
}

function applyTranslations($buttons) {
    const $vibeAsset = $(".vibe-community-asset");

    if ($vibeAsset.length < 1 || $buttons.length < 0) {
        return;
    }

    const translations = {
        all: $vibeAsset.data("all"),
        tennis: $vibeAsset.data("tennis"),
        badminton: $vibeAsset.data("badminton"),
        padel: $vibeAsset.data("padel"),
        pickleball: $vibeAsset.data("pickleball"),
        loadmore: $vibeAsset.data("loadmore")
    };

    $buttons.each(function (index, element) {
        const $el = $(element);
        const key = $el.text().toLowerCase();
        const filteredKey = key.indexOf("load more") > -1 ? "loadmore" : key;
        const translation = translations[filteredKey];
        
        if (translation && translation.length > 0) {
            $el.text(translation);
        }
    });
}